import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";
import { useCart } from "@/cart/CartContext";
import { Logo } from "@/components/Logo";

function navClass({ isActive }: { isActive: boolean }) {
  return [
    "rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
    isActive ? "bg-surface-alt text-ink" : "text-ink-soft hover:text-ink hover:bg-surface-alt",
  ].join(" ");
}

export function Layout() {
  const { isAuthenticated, user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-20 border-b border-line bg-surface/85 shadow-header backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-5 py-3">
          <Link to="/" className="shrink-0">
            <Logo />
          </Link>

          <nav className="ml-4 hidden items-center gap-1 sm:flex">
            <NavLink to="/" end className={navClass}>
              Catalog
            </NavLink>
            {isAuthenticated && (
              <>
                <NavLink to="/entitlements" className={navClass}>
                  My add-ons
                </NavLink>
                <NavLink to="/orders" className={navClass}>
                  Orders
                </NavLink>
              </>
            )}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <Link
              to="/cart"
              className="relative inline-flex items-center gap-1.5 rounded-lg border border-line bg-surface px-3 py-1.5 text-sm font-medium text-ink-soft transition-colors hover:text-ink hover:border-line-strong"
            >
              Cart
              {count > 0 && (
                <span className="grid h-5 min-w-5 place-items-center rounded-full bg-brand px-1 text-[0.68rem] font-bold text-white">
                  {count}
                </span>
              )}
            </Link>
            {isAuthenticated ? (
              <div className="flex items-center gap-2">
                <span className="hidden text-sm text-ink-mute md:inline" title={user?.email}>
                  {user?.email}
                </span>
                <button
                  onClick={logout}
                  className="rounded-lg border border-line px-3 py-1.5 text-sm font-medium text-ink-soft transition-colors hover:text-ink hover:border-line-strong"
                >
                  Sign out
                </button>
              </div>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="rounded-lg bg-brand px-4 py-1.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-strong"
              >
                Sign in
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-5 py-10">
        <Outlet />
      </main>

      <footer className="border-t border-line">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-5 py-6 text-sm text-ink-mute sm:flex-row">
          <span>© {new Date().getFullYear()} Piggy. All rights reserved.</span>
          <span>Secure payments by Stripe</span>
        </div>
      </footer>
    </div>
  );
}
